import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './firebase'
import 'bootswatch/dist/superhero/bootstrap.min.css'

ReactDOM.render(
  <React.Fragment>
    <App />
  </React.Fragment>,
  document.getElementById('root')
);

